module.exports = "/_next/static/images/TailoredProduct-2322093b4556a003cc0049b75514a18b.webp";